import React from "react";
import ConnectionsSection from "./ConnectionsSection";
import {
    Connection,
    PriorityType,
    UrgencyType,
    NetworkType,
} from "../../gql/types";

interface StaticConnectionsSectionProps {
    title: string;
    networkType: NetworkType;
    priorityType: PriorityType;
    urgencyType: UrgencyType;
    message?: string | null;
    connections: Connection[];
    count: number;
    isSelectMode: boolean;
    selectedIds: Set<string>;
    onToggle: (connectionIds: string[]) => void;
    openSection?: boolean;
}

const StaticConnectionsSection: React.FC<StaticConnectionsSectionProps> = ({
    title,
    networkType,
    priorityType,
    urgencyType,
    message,
    connections,
    count,
    isSelectMode,
    selectedIds,
    onToggle,
    openSection = false,
}) => {
    const edges = connections.map((conn) => ({
        __typename: "ConnectionEdge" as const,
        cursor: conn.connectionID,
        node: conn,
    }));

    return (
        <ConnectionsSection
            title={title}
            networkType={networkType}
            priorityType={priorityType}
            urgencyType={urgencyType}
            message={message}
            edges={edges}
            count={count}
            loading={false}
            isPaginated={false}
            pageInfo={undefined}
            loadMore={undefined}
            isSelectMode={isSelectMode}
            selectedIds={selectedIds}
            onToggle={onToggle}
            openSection={openSection}
        />
    );
};

export default StaticConnectionsSection;
